import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import "../style.css";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import { styled } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Dropdown } from "../../../assets/images/dropdown-arrow.svg";
import { ReactComponent as GreenDot } from "../../../assets/images/greendot.svg";
import { ReactComponent as RedDot } from "../../../assets/images/reddot.svg";
import { ReactComponent as GreyDot } from "../../../assets/images/greydot.svg";
import { listCoUser } from "../../../store/features/listCoUser";
import { suspendUserApi } from "../../../store/features/suspendCoUser";
import DeletePopUp from "../DeletePopUp";
import { deleteUserApi } from "../../../store/features/deleteCoUser";
import SearchInput from "../../common/SearchInputField";
import ButtonMain from "../../common/ButtonMain";
import MultipleEmail from "../MutliEmailSelect";
import SelectInputTeam from "../TeamSelectInput";
import AddGroupInput from "../GroupInput";
import { ReactComponent as Close } from "../../../assets/images/teamclose.svg";
import { ReactComponent as EmptyUserIcon } from "../../../assets/images/emptyUserIcon.svg";
import { InviteUserApi } from "../../../store/features/inviteUser";
import { CoUserInviteLink } from "../../../store/features/CoUserInviteLink";
import { coUserUpdateStatus } from "../../../store/features/coUserUpdateStatus";
import { logoutAgent } from "../../../store/features/logoutAgent";
import { setSelectedUser } from "../../../Redux/userSlice";
import TeamSideBar from "./TeamSideBar";
import Loader from "../../../../src/assets/Loader";
import { BASE_URL } from "../../../api/ApiConfig";
import { createAppSocket } from '../../../api/createAppSocket';
import { useSocket } from "../../../SocketContext";
import { logoutAll } from "../../../store/features/LogoutAll";
import TeamManagementSkeleton from "./TeamManagementSkeleton";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { selectActiveChatLimit, setActiveChatLimit } from "../../../Redux/teamSlice";
import {
  getTeamMgmtPeek,
  setTeamMgmtPeek,
  TEAM_MGMT_CACHE_TABS,
} from "../../../utils/teamManagementViewCache";


const ENDPOINT = `${BASE_URL}`;

const chracterPosition = (alphabet) => {
  const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
  return positionOfAlphabet;
};
const colorCodesForAvatar = [
  "#405261", "#FF4D4F", "#FA541C", "#FA8C16", "#FAAD14", "#EB2F96",
  "#FADB14", "#A0D911", "#52C41A", "#5CDBD3", "#9254DE", "#F759AB",
  "#2F54EB", "#722ED1", "#1890FF", "#13C2C2", "#2DB7F5", "#19BE6B",
  "#30A745", "#FA8C16", "#FAAD14", "#9254DE", "#F759AB", "#13C2C2",
  "#722ED1", "#2DB7F5",
];

function buildCoUserRowsFromApiData(payloadData) {
  const outputarray = [];
  if (!Array.isArray(payloadData) || !payloadData.length) return outputarray;
  payloadData.forEach((item) => {
    const userAvatars = item.user.groups.map((user) => {
      const firstLetter = user.name.charAt(0).toUpperCase();
      return user.group_image ? (
        <Avatar key={user.id} src={user.group_image} />
      ) : (
        <Avatar
          key={user.id}
          sx={{
            bgcolor: colorCodesForAvatar[
              chracterPosition((user.name ? user.name.substring(0, 1) : "").toUpperCase())
            ],
          }}
        >
          {firstLetter}
        </Avatar>
      );
    });

    outputarray.push({
      id: item?.user.id,
      img: item?.user?.agent_image,
      name: item?.user?.name,
      email: item?.user?.email,
      group: userAvatars,
      selected: false,
      role: item?.user?.role_name,
      isActive: item?.user.is_active,
      isJoined: item?.user.is_joined,
      isOffline: item?.user.is_offline,
      ActiveUser: item?.user.accept_chat ? "Accepting Chat" : "Not Accepting Chat",
      DotColor: item?.user.accept_chat ? <GreenDot /> : <RedDot />,
      menu: "...",
    });
  });
  return outputarray;
}

const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

function TeamCustomTable(props) {
  const userData = useSelector((state) => state.loginToken);
  const businessId = userData?.response?.user?.business_id;
  const allUsersPeek = getTeamMgmtPeek(businessId, TEAM_MGMT_CACHE_TABS.ALL_USERS);
  const initialCoUserRows =
    allUsersPeek?.rawData !== undefined
      ? buildCoUserRowsFromApiData(allUsersPeek.rawData)
      : [];

  const [isCreateUesr, setIsCreateUser] = useState(false);
  const [data, setData] = useState(initialCoUserRows);
  const [statusMenuPosition, setStatusMenuPosition] = useState(null);
  const [isGroupSidebarOpen, setIsGroupSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(initialCoUserRows);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [activeRowId, setActiveRowId] = useState(null);
  const [multiEmail, setMultiEmail] = useState([]); // Initialize as empty array based on usage
  const [pendingEmail, setPendingEmail] = useState("");
  const [teamUserId, setTeamUserId] = useState("");
  const [deleteUser, setDeleteUser] = useState(false);
  const [getUserList, setGetUserList] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [activeSidebar, setActiveSideBar] = useState(false);
  const [userName, setUserName] = useState("");
  const [buttonDisable, setButtonDisable] = useState(true);
  const [emailError, setEmailError] = useState("");
  const [allValid, setAllValid] = useState(true);
  const [isLoading, setIsLoading] = useState(allUsersPeek?.rawData === undefined);
  const [isInviteLoading, setIsInviteLoading] = useState(false);
  const [isThrottled, setIsThrottled] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUserForMenu] = useState(null);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const activeChatLimit = useSelector(selectActiveChatLimit);
  const dropdownRef = useRef(null);
  const toolbarRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const uID = userData.response?.user?._id;
  const uRole = userData.response?.user?.role_name;
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const t = useSelector((state) => state.language.translations[currentLanguage]);

  const { setUserGroupList, setChatLimitDetail, setUsersCount, onViewAllGroups } = props;
  const toastConfig = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  };
  const socketRef = useRef();
  const [toolbarHeight, setToolbarHeight] = useState(0);
  const UserInviteLink = async () => {
    if (isThrottled) return;
    setIsThrottled(true);

    try {
      const CoUserInviteLInk = await dispatch(CoUserInviteLink());

      if (CoUserInviteLInk?.payload?.status === 200) {
        const { invitationLink } = CoUserInviteLInk.payload;
        await navigator.clipboard.writeText(invitationLink);

        toast.success("Invitation link copied to clipboard");
      } else {
        toast.error(
          CoUserInviteLInk?.payload?.message ||
          "Some Error Occured. Please try again later.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
    } catch (error) {
      toast.error(error.message || "An error occurred", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setTimeout(() => setIsThrottled(false), 3000);
    }
  };
  // Socket setup
  useEffect(() => {
    socketRef.current = createAppSocket();
    socketRef.current.on("get-status", handleUpdateChatStatus);
    socketRef.current.on("check-login", handleLogin);
    socketRef.current.on("check-single-logout", handleLogout);
    socketRef.current.on("check-logout", handleLogout);

    return () => {
      socketRef.current.off("get-status", handleUpdateChatStatus);
      socketRef.current.off("check-login", handleLogin);
      socketRef.current.off("check-single-logout", handleLogout);
      socketRef.current.off("check-logout", handleLogout);
    };
  }, []);

  // Calculate toolbar height
  useEffect(() => {
    if (toolbarRef.current) {
      setToolbarHeight(toolbarRef.current.offsetHeight);
    }
  }, [filteredData.length]);

  // Calculate dynamic table height
  const tableContainerHeight = useMemo(() => {
    return `calc(100vh - ${350 + toolbarHeight}px)`;
  }, [toolbarHeight]);

  const handleLogout = (agentId) => {
    setFilteredData((prevData) =>
      prevData.map((item) =>
        item.id === agentId
          ? { ...item, isOffline: true, ActiveUser: "Offline", DotColor: <GreyDot /> }
          : item
      )
    );
  };

  const handleLogin = (agentId) => {
    setFilteredData((prevData) =>
      prevData.map((item) =>
        item.id === agentId
          ? { ...item, isOffline: false, ActiveUser: "Accepting Chat", DotColor: <GreenDot /> }
          : item
      )
    );
  };

  const handleUpdateChatStatus = (agentId, status) => {
    setFilteredData((prevData) =>
      prevData.map((item) =>
        item.id === agentId
          ? {
            ...item,
            ActiveUser: status ? "Accepting Chat" : "Not Accepting Chat",
            DotColor: status ? <GreenDot /> : <RedDot />,
          }
          : item
      )
    );
  };
  const handleEmailChange = (event, value) => {
    setMultiEmail(value);
  };
  const handleValueStore = useCallback((emails, currentInput = "") => {
    setPendingEmail(currentInput);
    setMultiEmail(emails);
  }, []);

  // Consolidated button state logic - only re-evaluate when dependencies change
  useEffect(() => {
    const hasEmails = multiEmail && multiEmail.length > 0;
    const hasValidInput = pendingEmail && validateEmail(pendingEmail.trim());
    const hasRole = userName && userName.trim() !== "";
    const shouldEnable = (hasEmails || hasValidInput) && hasRole;

    setButtonDisable(!shouldEnable);
  }, [userName, multiEmail, pendingEmail]);
  const getUserlList = async () => {
    const listCoUserList = dispatch(listCoUser());

    listCoUserList
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.");
          setIsLoading(false);
        } else if (data?.payload?.status === 200) {
          const list = Array.isArray(data.payload.data) ? data.payload.data : [];
          if (businessId) {
            setTeamMgmtPeek(businessId, TEAM_MGMT_CACHE_TABS.ALL_USERS, list);
          }
          const outputarray = buildCoUserRowsFromApiData(list);
          setUsersCount(outputarray);
          setData(outputarray);
          setFilteredData(outputarray);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          toast.error(data?.payload?.message || "Some Error Occured. Please try again later.");
        }
      })
      .catch(async (error) => {
        setIsLoading(false);
        toast.error(error.message);
      });
  };

  useEffect(() => {
    getUserlList();
  }, []);

  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setPage(0);
    const filteredResults = data.filter(
      (row) =>
        row.name.toLowerCase().includes(query) ||
        row.email.toLowerCase().includes(query)
    );
    setFilteredData(filteredResults);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // const handleStatusMenuClick = (event, row) => {
  //   event.stopPropagation();
  //   const rect = event.currentTarget.getBoundingClientRect();
  //   const viewportWidth = window.innerWidth;
  //   const menuWidth = 200;

  //   // Calculate if menu would overflow
  //   const wouldOverflow = rect.right + menuWidth > viewportWidth;

  //   setMenuPosition({
  //     left: wouldOverflow ? rect.left - menuWidth : rect.right
  //   });
  //   setStatusAnchorEl(event.currentTarget);
  //   setSelectedUserForMenu(row);
  // };
  const visibleRows = useMemo(() => {
    return filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  const handleRowClick = (row) => {
    setActiveSideBar(row.id);
    setActiveRowId(prev => prev === row.id ? null : row.id);
    setGetUserList(row);
    dispatch(setSelectedUser("heello world"));
  };

  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedUserForMenu(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserForMenu(null);
  };
  const InviteCoUser = async () => {
    setIsInviteLoading(true);
    let emailList = [];
    if (Array.isArray(multiEmail)) {
      emailList = multiEmail.map((item) => item.email);
    } else if (multiEmail) {
      // Fallback if multiEmail is somehow not an array (though it should be)
      // The original code was: const emailString = multiEmail.map((item) => item.email).join(",");
      // which implies multiEmail is an array of objects.
    }

    // Check for pending valid email that hasn't been added as a chip yet
    if (pendingEmail && validateEmail(pendingEmail.trim())) {
      const pending = pendingEmail.trim();
      if (!emailList.includes(pending)) {
        emailList.push(pending);
      }
    }

    const emailString = emailList.join(",");
    const emailArray = emailList; // InviteUserApi expects array in requestHeaders based on original code?
    // Original: const emailString = multiEmail.map((item) => item.email).join(",");
    // const emailArray = emailString.split(",");

    // So emailArray is just array of strings.

    const roleId =
      userName === "admin_with_billing"
        ? "admin_with_billing"
        : userName === "agent"
          ? "agent"
          : userName === "admin"
            ? "admin"
            : userName === "supervisor"
              ? "supervisor"
              : null;


    const addCoUserDisptacher = dispatch(
      InviteUserApi({
        requestHeaders: {
          email: emailArray,
          role_name: roleId,
          agent_group_id: selectedGroups,
          timezone: userTimeZone,
        },
      })
    );

    try {
      const data = await addCoUserDisptacher;

      if (typeof data.payload === "undefined") {
        toast.error(
          "Some Error Occurred. Please try again later.",
          toastConfig
        );
        setIsInviteLoading(false);
      } else if (data?.payload?.status === 200) {
        const invitations = data?.payload?.invitations || [];
        invitations.forEach((invitation) => {
          if (invitation.status === 400) {
            toast.error(`${invitation.message}`, toastConfig);
            setIsInviteLoading(false);
          } else {
            toast.success(data?.payload?.message, toastConfig);
            setIsCreateUser(false);
            setSelectedGroups('')
            setUserName('')
            getUserlList();
            setIsInviteLoading(false);
          }
        });
      } else if (data?.payload?.status === 400) {
        toast.error("some error occured");
        setIsCreateUser(false);
        setIsInviteLoading(false);
      } else if (data?.payload?.status === 401) {
        setIsCreateUser(false);
        toast.error("Login Expired. Please login and try again.", toastConfig);
        setIsInviteLoading(false);
      }
    } catch (error) {
      setIsCreateUser(false);
      toast.error(error.message || "An error occurred.", toastConfig);
      setIsInviteLoading(false);
    }

  };
  const handleStatusMenuClick = (event, row) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();

    setStatusMenuPosition({
      top: rect.bottom + window.scrollY, // Position below the clicked element
      left: rect.left + window.scrollX,  // Align with the left edge of clicked element
    });
    setSelectedUserForMenu(row);
  };
  const handleStatusMenuClose = () => {
    setStatusMenuPosition(null);
    setSelectedUserForMenu(null);
  };

  const chatStatusUpdate = async (agentId, status) => {
    const CoUserUpdates = dispatch(
      coUserUpdateStatus({
        id: agentId,
        requestHeaders: { accept_chat: status },
      })
    );

    CoUserUpdates.then(async (data) => {
      if (data?.payload?.status === 200) {
        getUserlList();
        socketRef.current.emit("update-status", agentId, status);
        handleStatusMenuClose();
      }
    }).catch(async (error) => {
      toast.error(error.message);
    });
  };

  const logoutUser = async (agentId) => {
    const CoUserUpdates = dispatch(
      logoutAgent({
        requestHeaders: { agentId: agentId, adminId: uID },
      })
    );

    CoUserUpdates.then(async (data) => {
      socketRef.current.emit("logout-agent", agentId);
      if (agentId === userData.response?.user?._id) {
        await dispatch(logoutAll());
      }
      if (data?.payload?.status === 200) {
        getUserlList();
        handleStatusMenuClose();
      }
    }).catch(async (error) => {
      toast.error(error.message);
    });
  };

  const suspendUserHandler = async (rowId) => {
    const suspendUserList = dispatch(
      suspendUserApi({ requestHeaders: { id: rowId } })
    );

    suspendUserList.then(async (data) => {
      if (data?.payload?.success === true) {
        toast.success(data?.payload?.message);
        handleMenuClose();
        getUserlList();
        props.onSuspenseChange();
        socketRef.current.emit("logout-agent", rowId);
      }
    }).catch(async (error) => {
      toast.error(error.message);
    });
  };

  const deleteUserHandler = async () => {
    const deleteuserList = dispatch(
      deleteUserApi({ requestHeaders: { id: teamUserId } })
    );

    deleteuserList.then(async (data) => {
      if (data?.payload?.status === 200) {
        toast.success(data?.payload?.message);
        getUserlList();
      }
    }).catch(async (error) => {
      toast.error(error.message);
    });
  };

  const activeCount = filteredData.filter((row) => row.isActive).length;
  const inviteCount = filteredData.filter((row) => row.isJoined).length;

  if (isLoading) {
    return <TeamManagementSkeleton showButton={true} />;
  }

  const headCells = [
    { id: "name", label: t.NAMETB },
    { id: "email", label: t.EMAILTB },
    { id: "groups", label: t.GROUPS },
    { id: "role", label: t.ROLETB },
    { id: "status", label: t.STATUSTB },
    { id: "actions", label: "" },
  ];

  return (
    <div>
      <div ref={toolbarRef} className="team-container">
        <SearchInput
          title=""
          placeholder="Search"
          className="SearchInputField-teamsection"
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
        <ButtonMain
          showIcon
          className="inviteButton-team"
          onClick={() => setIsCreateUser(true)}
          title={t.ADDMEMBERROLE}
        />
      </div>

      <div className="Team-Section-Content-Container">
        {parseInt(filteredData?.length) < 1 ? (
          <div className="NoSuspendedAgent-main-Conatiner">
            <div className="TeamChatBot-Main-Container">
              <EmptyUserIcon />
              <p className="Chatbot-devploment">{t.NOAVAILABLEUSERS}</p>
              <p className="Chatbot-crafting">{t.NOAVAILABLEUSERSMSG}</p>
            </div>
          </div>
        ) : (
          <>
            <p className="Team-total-active-user">
              Active ({activeCount}) <span className="Space-Left">Invite Sent ({inviteCount})</span>
            </p>

            <TableContainer
              sx={{
                boxShadow: "none",
                flex: 1,
                marginTop: "2px",
                marginBottom: "40px",
                height: tableContainerHeight,

                overflowY: "auto",
              }}
            >
              <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                <TableHead>
                  <TableRow
                    sx={{
                      zIndex: 15,
                      bottom: 0,
                      '& th': {
                        color: '#405261',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        fontWeight: 400,
                        paddingTop: '0px',
                        paddingBottom: '0px',

                      },
                    }}
                  >
                    {headCells.map((headCell, index) => (
                      <TableCell
                        key={headCell.id}
                        sx={{
                          paddingLeft: index === 0 ? '0px' : '16px',
                          paddingTop: '0px',
                          paddingBottom: '9px !important',
                          zIndex: activeChatLimit
                            ? 'unset'
                            : (!activeSidebar && !isCreateUesr && !deleteUser ? 7 : 1),

                          lineHeight: '0',
                        }}
                      >
                        <Typography sx={{ fontSize: '12px', fontWeight: 400, margin: 0 }}>
                          {headCell.label}
                        </Typography>
                      </TableCell>

                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {visibleRows.map((row) => (
                    <TableRow
                      key={row.id}
                      hover
                      onClick={() => handleRowClick(row)}

                      sx={{
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#F9FAFA !important",
                        },

                        // "&.Mui-selected:hover": {
                        //   backgroundColor: "#F9FAFA !important",
                        // },
                        "& td": {
                          height: "4rem", py: 0, verticalAlign: "middle",
                          color: "#405261",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,


                        },
                      }}
                    >

                      <TableCell style={{ paddingLeft: 0, }}>
                        <div className="team-table-img">
                          {row.img ? (
                            <Avatar src={row.img} alt="users logo" sx={{ width: 32, height: 32 }} />
                          ) : (
                            <Avatar
                              sx={{
                                width: 32,
                                height: 32,
                                fontSize: '16px',
                                bgcolor: colorCodesForAvatar[
                                  chracterPosition((row.name ? row.name.substring(0, 1) : "").toUpperCase())
                                ],
                              }}
                            >
                              {(row.name ? row.name.substring(0, 1) : "").toUpperCase()}
                            </Avatar>
                          )}
                          <p className="team-table-rowtext">{row.name}</p>
                        </div>
                      </TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell  >
                        <AvatarGroup
                          max={4}
                          sx={{

                            WebkitJustifyContent: 'left',
                            '& .MuiAvatar-root': {
                              width: 32,
                              height: 32,
                            },

                            '& .MuiAvatar-root:nth-of-type(2)': {
                              zIndex: !activeChatLimit
                                ? (!activeSidebar && !isCreateUesr && !deleteUser ? 2 : 1)
                                : 'unset',

                              marginLeft: '-8px',
                            },
                            '& .MuiAvatar-root:nth-of-type(3)': {
                              zIndex: !activeChatLimit ? 1 : 0,
                              marginLeft: '-8px',
                            },
                            '& .MuiAvatar-root:nth-of-type(4)': {
                              zIndex: 0,
                              marginLeft: '-8px',

                            },
                            '& .MuiAvatarGroup-avatar': {
                              zIndex: !activeChatLimit
                                ? (!activeSidebar && !isCreateUesr && !deleteUser ? 5 : 1)
                                : 'unset',

                              textAlign: 'center',
                              fontFamily: 'Inter',
                              fontSize: '14px',
                              fontStyle: 'normal',
                              fontWeight: 500,
                              lineHeight: '18px',
                              transition: 'filter 0.3s ease',
                              border: 'none',
                              width: 32,
                              height: 32,
                            }
                          }}
                        >
                          {row.group.map((avatar, index) => (
                            <Avatar
                              key={avatar.key}
                              src={avatar.props.src}
                              sx={avatar.props.sx}
                            >
                              {avatar.props.children}
                            </Avatar>
                          ))}
                        </AvatarGroup>
                      </TableCell>
                      <TableCell>
                        {row.role.charAt(0).toUpperCase() + row.role.slice(1)}
                      </TableCell>
                      <TableCell sx={{
                        color: "#061522",

                        fontWeight: 500,
                        '& svg': {
                          display: 'inline-block',
                          // width: 14,
                          // height: 14,
                          verticalAlign: 'middle',
                          overflow: 'visible',
                          flexShrink: 0,
                        },

                      }}>
                        {row.isJoined && !row.isOffline ? (
                          <div
                            className="team-activeuser"
                            onClick={(e) => {
                              if (uRole === "admin" || uRole === "admin_with_billing" || row.id === uID) {
                                handleStatusMenuClick(e, row);
                              }
                            }}
                            style={{ cursor: (uRole === "admin" || uRole === "admin_with_billing" || row.id === uID) ? "pointer" : "default" }}
                          >
                            {row.DotColor}
                            {row.ActiveUser}
                            {(uRole === "admin" || uRole === "admin_with_billing" || row.id === uID) && <Dropdown />}
                          </div>
                        ) : row.isOffline ? (
                          <div className="team-activeuser">
                            <GreyDot /> Offline
                          </div>
                        ) : (
                          <div className="team-invitation-sent">Invitation sent</div>
                        )}
                      </TableCell>
                      <TableCell padding="none">
                        {(uRole === "admin" || uRole === "admin_with_billing" || row.id === uID) &&
                          !(uRole === "admin" && row.role === "admin_with_billing") && (
                            <IconButton
                              onClick={(e) => handleMenuClick(e, row)}
                              size="small"
                              sx={{ ml: 1, "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" } }}
                            >
                              <MoreHorizIcon />
                            </IconButton>
                          )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {!activeSidebar && !isCreateUesr && !deleteUser && !activeChatLimit && filteredData.length > 0 && <Box
              sx={{
                position: "sticky",
                bottom: 0,
                left: 0,
                width: "100%",
                padding: "16px 24px",
                background: "#fff",
                zIndex: 10,
                borderTop: "1px solid #E5E9EC",
              }}
            >
              <TablePagination
                component="div"
                count={filteredData.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={({ from, to, count }) => (
                  <Typography
                    sx={{
                      color: "#405261",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "18px",
                    }}
                  >
                    Team {from}-{to}
                  </Typography>
                )}
                ActionsComponent={(props) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      marginLeft: "auto",
                      // marginTop: "15px",
                    }}
                  >
                    <Button
                      onClick={(e) => props.onPageChange(e, props.page - 1)}
                      disabled={props.page === 0}
                      sx={{
                        width: "128px",
                        height: "40px",
                        flexShrink: 0,
                        borderRadius: "8px",
                        border: "1px solid #D5DCE1",
                        background: "#FFF",
                        boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
                        color: "#405261",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        textTransform: "none",
                        "&:not(.Mui-disabled):hover": {
                          backgroundColor: "#FFFFFF",

                          borderColor: "#C5CED6",
                        },
                        "&.Mui-disabled": {
                          color: "#93A1B0",
                          border: "1px solid #C5CED6",
                          bgcolor: "#F9FAFA",
                        },
                      }}
                    >
                      Previous
                    </Button>
                    <Button
                      onClick={(e) => props.onPageChange(e, props.page + 1)}
                      disabled={
                        props.page >= Math.ceil(props.count / rowsPerPage) - 1
                      }
                      sx={{
                        width: "88px",
                        height: "40px",
                        flexShrink: 0,
                        borderRadius: "8px",
                        border: "1px solid #D5DCE1",

                        boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
                        color: "#405261",
                        backgroundColor: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        textTransform: "none",
                        "&:not(.Mui-disabled):hover": {
                          backgroundColor: "#FFFFFF",

                          borderColor: "#C5CED6",
                        },
                        "&.Mui-disabled": {

                          color: "#93A1B0",
                          border: "1px solid #C5CED6",
                          bgcolor: "#F9FAFA",
                        },
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                )}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    padding: 0,
                    minHeight: "unset",
                    display: "flex",
                    justifyContent: "space-between",
                  },
                  ".MuiTablePagination-spacer": {
                    display: "none",
                  },
                  ".MuiTablePagination-selectLabel": {
                    display: "none",
                  },
                  ".MuiTablePagination-select": {
                    display: "none",
                  },
                  ".MuiTablePagination-selectIcon": {
                    display: "none",
                  },
                }}
              /> </Box>}
          </>
        )}
        {isCreateUesr && (
          <div>
            <div className="overlay" />
            <div style={{ zIndex: 1 }} className="Team-PopUp-Container">
              <div className="Team-PopUp-Header">
                <p className="PopUp-Text01">{t.ADDMEMEBER}</p>
                <p
                  className="PopUp-Text02"
                  onClick={() => { setIsCreateUser(false), setSelectedGroups(''), setUserName('') }}
                >
                  <Close />
                </p>
              </div>

              <div className="PopUp-Email-Container">
                <p style={{ marginBottom: "5px" }}>{t.TITLE_EMAIL}</p>
                <MultipleEmail
                  name="emailInput"
                  value={multiEmail}
                  onChange={handleEmailChange}
                  sendValueStore={handleValueStore}
                  id="tags-outlined"
                />
                {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                <br />
                <p>{t.ASSIGNROLE}</p>
                <SelectInputTeam
                  value={userName}
                  onChange={(e) => {
                    setUserName(e);
                  }}
                />
                <br />
                <p>{'Add Groups'}</p>
                <AddGroupInput
                  selectedGroups={selectedGroups}
                  setSelectedGroups={setSelectedGroups}
                />
                <br />
                <ButtonMain
                  title="Copy invite link"
                  className="buttonStyleTeam"
                  onClick={UserInviteLink}
                  disabled={isThrottled}
                />
                <ButtonMain
                  title="Send Invite"
                  className={buttonDisable || isInviteLoading ? 'buttonStyleDisable-team' : "buttonStyleEnable-team"}
                  onClick={() => InviteCoUser()}
                  disabled={buttonDisable || isInviteLoading}

                />
              </div>
            </div>
          </div>
        )}
        {/* Status Menu */}
        <Menu
          open={Boolean(statusMenuPosition)}
          onClose={handleStatusMenuClose}
          anchorReference="anchorPosition"
          anchorPosition={statusMenuPosition}
          transformOrigin={{ vertical: "top", horizontal: "left" }}

          PaperProps={{
            elevation: 0,
            sx: {
              filter: "none",
              color: '#405261',
              mt: 1.5,
              width: 200,
              paddingX: "8px",
              borderRadius: "8px", // ✅ your custom border radius
              border: "1px solid #D5DCE1", // ✅ your custom border

              boxShadow: "0 15px 20px 0 rgba(6, 21, 34, 0.05)", // ✅ soft shadow
              "& .MuiMenuItem-root": {
                px: "8px",
                py: 1,
                fontSize: '14px',
                fontFamily: 'Inter',
                color: '#405261',

                "&:hover": { color: "#061522", borderRadius: "8px", background: "#F9FAFA !important" },
              },
            },
          }}
        >
          <MenuItem onClick={() => chatStatusUpdate(selectedUser?.id, true)}>
            <GreenDot style={{ marginRight: 8 }} />
            {t.ACCEPTCHAT}
          </MenuItem>

          <MenuItem onClick={() => chatStatusUpdate(selectedUser?.id, false)}>
            <RedDot style={{ marginRight: 8 }} />
            {t.NOTACCEPT}
          </MenuItem>

          <MenuItem onClick={() => logoutUser(selectedUser?.id)}>
            <GreyDot style={{ marginRight: 8 }} />
            {t.LOGOUT}
          </MenuItem>
        </Menu>


        {/* Actions Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            elevation: 0,
            sx: {
              filter: "none",
              color: '#405261',
              mt: '-5px',
              width: 200,
              paddingX: "8px",
              borderRadius: "8px", // ✅ your custom border radius
              border: "1px solid #D5DCE1", // ✅ your custom border

              boxShadow: "0 15px 20px 0 rgba(6, 21, 34, 0.05)", // ✅ soft shadow
              "& .MuiMenuItem-root": {
                px: "8px",
                py: 1,
                fontSize: '14px',
                fontFamily: 'Inter',
                color: '#405261',

                "&:hover": { color: "#061522", borderRadius: "8px", background: "#F9FAFA !important" },
              },
            },
          }}
        >
          <MenuItem onClick={() => { handleMenuClose(); navigate(`/userupdate/${selectedUser?.id}`); }}>
            {t.EDITPROFILE}
          </MenuItem>
          <MenuItem onClick={() => {
            setChatLimitDetail({ id: selectedUser?.id, name: selectedUser?.name, email: selectedUser?.email, img: selectedUser?.img });
            dispatch(setActiveChatLimit(true));
            handleMenuClose();
          }}>
            {t.CHANGECHAT}
          </MenuItem>
          <MenuItem onClick={handleMenuClose}>{t.VIEWAGENT}</MenuItem>
          {(uRole === "admin" || uRole === "admin_with_billing") && !(selectedUser?.id === uID) && (
            <>
              <MenuItem onClick={() => { suspendUserHandler(selectedUser?.id); }}>{t.SUSPENSEAGENT}</MenuItem>
              <MenuItem sx={{
                color: '#FF4D4F !important',
                "&:hover": {
                  color: '#FF4D4F !important',
                  background: "#F9FAFA !important",
                  borderRadius: '8px'
                },
              }} onClick={() => { setTeamUserId(selectedUser?.id); setDeleteUser(true); handleMenuClose(); }}>
                {t.DELETEALL}
              </MenuItem>
            </>
          )}
        </Menu>

        {deleteUser && (
          <DeletePopUp
            onCancel={() => setDeleteUser(false)}
            onDelete={() => { deleteUserHandler(); setDeleteUser(false); }}
          />
        )}

        {activeSidebar && (
          <>
            <div className="overlay" />
            <TeamSideBar
              onViewAllGroups={onViewAllGroups}
              onCancel={() => setActiveSideBar(false)}
              onOpen={() => setActiveSideBar(true)}
              userList={getUserList}
            />
          </>
        )}
      </div>
    </div >
  );
}

export default TeamCustomTable;